import { render, staticRenderFns } from "./NonTradingCustomers.vue?vue&type=template&id=988cceac&scoped=true&"
import script from "./NonTradingCustomers.vue?vue&type=script&lang=ts&"
export * from "./NonTradingCustomers.vue?vue&type=script&lang=ts&"
import style0 from "./NonTradingCustomers.vue?vue&type=style&index=0&id=988cceac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988cceac",
  null
  
)

export default component.exports